import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

import {MerchantPenaltyDetailResponse} from './interfaces'

/**
 * 가맹점 fds 검수상태 확인
 * @param merchantNos
 */
export const getFdsMerchantPenalty = async (merchantNos: string[]) => {
    const api = getApi(getCommonBaseUrl())
    return createWrapper<MerchantPenaltyDetailResponse>(
        api.post(`/fds/merchant/penaltyDetails`, {
            merchantNos,
        }),
    )
}
